import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Field, FastField, FieldProps } from 'formik';

import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { StyledDatepicker } from 'src/kit';
import { FormikErrorMessage } from './FormikErrorMessage';

const FormikDatepicker = ({ isFast, name, validate, dateFormat, ...restProps }: any) => {
  const FieldComponent = isFast ? FastField : Field;
  const ref = useRegisteredRef(name);

  return (
    <FieldComponent name={name} validate={validate}>
      {({ field, form: { touched, errors, setFieldValue } }: FieldProps) => {
        const momentValue = field.value && moment(field.value);
        const value = momentValue && momentValue.isValid() ? momentValue.format(dateFormat) : field.value;
        const error = get(touched, name) && get(errors, name);
        return (
          <>
            <StyledDatepicker
              ref={error ? ref : undefined}
              name={name}
              dateFormat={dateFormat}
              value={value}
              onBlur={() => field.onBlur(name)}
              onChange={v => setFieldValue(name, typeof v === 'string' ? v : v?.format(dateFormat))}
              closeOnSelect={true}
              error={error}
              {...restProps}
            >
              <FormikErrorMessage name={name} />
            </StyledDatepicker>
          </>
        );
      }}
    </FieldComponent>
  );
};

export default FormikDatepicker;
